module.exports = __webpack_public_path__ + "static/media/collage_compare_vials.cede4109.webp";